import router from '@/router'; // Adjust path to your router
import { useToast } from 'vue-toastification'; // Import the composable

export const logoutOnTokenExpired = () => {

  const toast = useToast();
  // Use the toast instance directly
  toast.error('Session expired. Redirecting to login.', {
    hideProgressBar: false,
    icon: false,
    timeout: 8000,
  });
  
  localStorage.removeItem('SSCUSER'); // Or sessionStorage if preferred
  router.push('/'); // Or '/login'
  console.warn('Token expired. Redirecting to login.');
  

};